import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  imports: [RouterModule, MatSidenavModule, MatToolbarModule],
  selector: 'pm-app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Protocols Management Portal';
}
